module.exports = __webpack_public_path__ + "static/img/5.ba3ef52.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/sp/5.png
// module id = yBqg
// module chunks = 0